import React, { useEffect, useState } from 'react';
import { Button, FilterWidget, FormRangePicker, MasterDetailForm, Widget } from '@digital/ui';
import {
  Demanda,
  ExportarDemandaConcluido,
  getDemandasDemandante,
  getDemandasDemandanteConcluido,
  getDemandasPreSuprimentosConcluido,
} from '@app/api/demanda';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import { Tooltip } from 'antd';
import GridDemandas from './GridDemandas';

const DemandasConcluido = (props: any) => {
  const [dados, setDados] = useState<Demanda[]>([]);
  const [update, setUpdate] = useState(false);
  const [periodoInicio, setPeriodoInicio] = useState(null);
  const [periodoFim, setPeriodoFim] = useState(null);
  const { usuarioPreSuprimentosOuAdmContratos } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  // guarda os filtros de coluna e a ordenação da grade para o export sair igual à tela
  const [filtrosGrade, setFiltrosGrade] = useState<{
    filters?: Record<string, (string | number)[] | null>;
    sorter?: any;
  }>({});

  // período efetivamente pesquisado; o do formulário só vale depois do Pesquisar
  const [periodoPesquisado, setPeriodoPesquisado] = useState<{ inicio: any; fim: any }>({
    inicio: null,
    fim: null,
  });

  const onUpdate = () => {
    setUpdate(!update);
  };

  const filtroBase = {
    PreSuprimentos: usuarioPreSuprimentosOuAdmContratos,
    ConcluidoCancelado: true,
    PeriodoInicio: periodoInicio,
    PeriodoFim: periodoFim,
  };

  const listarDemandas = (
    pagination: { current?: number; pageSize?: number } = {},
    filters?: Record<string, (string | number)[] | null>,
    sorter?: any,
  ) => {
    const { current = 1, pageSize = 10 } = pagination;

    setFiltrosGrade({ filters, sorter });
    setPeriodoPesquisado({ inicio: periodoInicio, fim: periodoFim });

    getDemandasDemandante(filtroBase, current, pageSize, filters, sorter).then(data => {
      if (data) {
        setDados(data.items);
        setPageSize(data.pageSize);
        setTotalPage(data.totalPages);
        setTotalItems(data.totalItems);
      }
    });
  };

  useEffect(() => {
    listarDemandas();
  }, [update]);

  const [exportando, setExportando] = useState(false);

  const handleExportar = async () => {
    try {
      setExportando(true);
      await ExportarDemandaConcluido(
        { ...filtroBase, PeriodoInicio: periodoPesquisado.inicio, PeriodoFim: periodoPesquisado.fim },
        filtrosGrade.filters,
        filtrosGrade.sorter,
      );
    } finally {
      setExportando(false);
    }
  };

  return (
    <>
      <FilterWidget
        title="Filtro"
        key="filterWidget"
        actions={[
          <Button type="primary" key="filterBtn" onClick={() => onUpdate()}>
            Pesquisar
          </Button>,
        ]}>
        <MasterDetailForm>
          <FormRangePicker
            value={[periodoInicio, periodoFim]}
            startName="dataInicio"
            endName="dataFinal"
            format={dateFormat}
            label="Período"
            span={4}
            onChange={dates => {
              setPeriodoInicio(dates[0]);
              setPeriodoFim(dates[1]);
            }}
          />
        </MasterDetailForm>
      </FilterWidget>
      <Widget
        title="Concluídos / Cancelados"
        actions={[
          <Tooltip title="Exportar demandas" key="exportarBtn">
            <Button
              id="mrn-btn-exportar-demanda-concluido"
              type="link"
              icon="files-xls"
              onClick={handleExportar}
              style={{ marginRight: '8px' }}
              loading={exportando}
            />
          </Tooltip>,
        ]}>
        <GridDemandas
          dados={dados}
          currentPage={currentPage}
          pageSize={pageSize}
          totalPage={totalPage}
          totalItens={totalItems}
          fetchData={listarDemandas}
        />
      </Widget>
    </>
  );
};
export default DemandasConcluido;
